var $8f86f40be75387f1$exports = {};
$8f86f40be75387f1$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "Polo\u017Eka ".concat(args.item, " nen\xED vybr\xE1na.");
  },
  "longPressToSelect": "Dlouh\xFDm stisknut\xEDm p\u0159ejdete do re\u017Eimu v\xFDb\u011Bru.",
  "select": "Vybrat",
  "selectedAll": "Vybr\xE1ny v\u0161echny polo\u017Eky.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "Nevybr\xE1ny \u017E\xE1dn\xE9 polo\u017Eky",
      one: function one() {
        return "Vybr\xE1na ".concat(formatter.number(args.count), " polo\u017Eka");
      },
      other: function other() {
        return "Vybr\xE1no ".concat(formatter.number(args.count), " polo\u017Eek");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "Vybr\xE1na polo\u017Eka ".concat(args.item, ".");
  }
};
export { $8f86f40be75387f1$exports as default };